/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

/**
 * Returns the title for the delivery based on the delivery mode.
 * @param {string} deliveryMode - The delivery mode.
 * @returns {string} - The title for the delivery.
 */
export const getOrderTypeFromDeliveryMode = (deliveryMode: string): string => {
  if (deliveryMode === 'Pickup') {
    return 'Pickup';
  } else if (deliveryMode === 'WarePickup') {
    return 'Seed pickup';
  } else if (deliveryMode === 'Card') {
    return 'Farmlands Card';
  } else if (deliveryMode === '') {
    return 'In Store Purchase';
  } else {
    return 'Delivery';
  }
};

export default getOrderTypeFromDeliveryMode;
